// import Vue from "vue";
// import Vuex from "vuex";

// Vue.use(Vuex);

// const getData = JSON.parse(localStorage.getItem("schedule")) || [];

// const store = new Vuex.Store({
//   state: {
//     scheduleData: getData,
//     selScheduleData: null,
//     planType: {
//       planColHexaCd: null,
//       planTyNm: null,
//       note: null,
//     },
//   },
//   mutations: {
//     createSchedule(state, payload) {
//       const newData = getData.concat(payload);
//       state.scheduleData = newData;
//       localStorage.setItem("schedule", JSON.stringify(newData));
//     },
//     selectSchedule(state, payload) {
//       state.selScheduleData = payload;
//     },
//     setPlanType(state, payload) {
//       state.planType = payload;
//     },
//   },
//   actions: {
//     SELECT_DATE({ commit }, payload) {
//       commit("selectSchedule", payload);
//     },
//     CREATE_SCHEDULE({ commit }, payload) {
//       commit("createSchedule", payload);
//     },
//     SET_PLANTYPE({ commit }, payload) {
//       commit("setPlanType", payload);
//     },
//   },
// });

// export default store;

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import schedule from "@/store/schedule";
import settingPlanTy from "@/store/settingPlanTy";

const store = new Vuex.Store({
  modules: {
    schedule,
    settingPlanTy,
  },
});

export default store;
